import { useState } from 'react';
import { Header } from './components/Header';
import { MiningControls } from './components/MiningControls';
import { StatusLog } from './components/StatusLog';
import { LiveActivityFeed } from './components/LiveActivityFeed';
import { WithdrawProfit } from './components/WithdrawProfit';
import { useMiningLogs } from './hooks/useMiningLogs';

function App() {
  const [isMining, setIsMining] = useState(false);
  const { logs, setLogs, totalProfit, setTotalProfit } = useMiningLogs(isMining);
  const [wasWithdrawn, setWasWithdrawn] = useState(false);

  const handleWithdraw = () => {
    setWasWithdrawn(true);        // trigger MiningControls update
    const balance = localStorage.getItem('totalMined') ?? "0"
    setTotalProfit(parseFloat(balance));
    setTimeout(() => {
      setWasWithdrawn(false)
      setTotalProfit(0);
    }, 1200); // optional cooldown/reset
  };

  return (
<div className="relative min-h-screen bg-white text-gray-800 font-sans">
<Header />

      <main className="px-4 md:px-6 py-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left Column */}
        <div className="space-y-6 md:col-span-2">
          <div className="glass-card min-h-[220px]">
            <MiningControls
              isMining={isMining}
              onToggleMining={() => setIsMining(!isMining)}
              totalProfit={totalProfit}
              wasWithdrawn={wasWithdrawn}
            />

          </div>

          <div className="glass-card min-h-[220px]">
            <WithdrawProfit totalProfit={totalProfit} resetProfit={handleWithdraw} />
          </div>
        </div>

        {/* Right Column */}
        <div className="glass-card min-h-[460px]">
          <StatusLog logs={logs} onClear={() => setLogs([])} />
        </div>
      </main>

      {/* Live Activity Feed - Responsive Floating */}
      <div className="fixed bottom-4 right-4 md:right-6 md:bottom-6 z-50 w-full max-w-sm px-4 md:px-0">
        <div className="glass-card shadow-2xl p-4">
          <LiveActivityFeed />
        </div>
      </div>

    </div>
  );
}

export default App;
